module.exports = "<input \n  type=\"number\"\n  ref=\"inputElement\" \n  class=\"wc-input wc-table-input-edit\" \n  v-if=\"edit\" \n  v-model=\"value\" \n  v-on:focus=\"editStart\"\n  v-on:blur=\"editComplete\" \n  v-on:keyup.enter.stop=\"editComplete\"\n  v-on:keyup.esc.stop=\"stopEdit(true)\" \n  v-on:keydown.stop\n  v-on:click.stop\n  v-on:keydown=\"validateKey\"\n  v-focus\n/>"


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/src/wc-ui/components/table/editors/table-cell-edit-number.html
// module id = 990
// module chunks = 0